import React from 'react';
import { EditorProvider } from './contexts/EditorContext';
import { Landing } from './pages/Landing';
interface AppProps {
  /** Editor view: shows "pending" flags and the testimonial placeholder. Turn off to preview the published page. */
  editorPreview?: boolean;
}
export function App({
  editorPreview = true
}: AppProps) {
  return <EditorProvider value={editorPreview} data-id="element-0" data-mp="3fb9jlbjc9enm">
      <Landing data-id="element-1" data-mp="2rknlod31tarc" />
    </EditorProvider>;
}